import KendoDataSourceBase from '../KendoDataSourceBase'
import GanttDataSourceProps from './GanttDataSourceProps'

import Schema from './Schema'

export default {
    props: GanttDataSourceProps,
    mixins: [
        KendoDataSourceBase, 
        Schema
    ],
    mounted() {
        this.kendoDataSource = new kendo.data.GanttDataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.data.GanttDataSource(this.widgetOptions)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoGanttDataSource/KendoGanttDataSourceMixin.js